import * as React from 'react';
import lazy from 'common/components/Lazy';

// 登录/注册路由加载
export default {
    SSO: lazy(async () => await import('./SSO/SSO')),
    SSOErrorPage: lazy(async () => await import('./SSOErrorPage/SSOErrorPage')),
} as Record<string, React.ComponentClass>;
